import React from 'react';
import classes from './Burger.css';
const burger = (props) => (
<div onClick={props.clicked} className={classes.appBurger}>
                    <div></div>
                    <div></div>
                    <div></div>
</div>
);


export default burger;


// WEBPACK FOOTER //
// ./src/components/UI/Burger/Burger.js